/*
  menara-associer.js — section « À associer » (sections/menara-coussin-associer.liquid).

  Quand la section attend les recommandations de Shopify, elle est rendue vide
  et masquée. Ce script demande la même section à l'API de rendu, récupère les
  cartes et n'affiche la section que s'il y en a. Sans réponse utile, rien ne
  s'affiche : jamais un titre suivi du vide.
*/

class MenaraAssocier extends HTMLElement {
  connectedCallback() {
    if (this.demarre || !this.hasAttribute('data-mas-charger')) return;
    this.demarre = true;
    this.charger();
  }

  async charger() {
    const url = this.dataset.url;
    const grille = this.querySelector('[data-mas-grille]');
    if (!url || !grille) return;
    try {
      const reponse = await fetch(url);
      if (!reponse.ok) return;
      const html = new DOMParser().parseFromString(await reponse.text(), 'text/html');
      const recues = html.querySelector('[data-mas-grille]');
      if (!recues || recues.children.length === 0) return;
      grille.innerHTML = recues.innerHTML;
      this.removeAttribute('hidden');
    } catch (erreur) {
      console.warn('[à associer] recommandations indisponibles', erreur);
    }
  }
}

if (!customElements.get('menara-associer')) {
  customElements.define('menara-associer', MenaraAssocier);
}
